module.exports = __webpack_public_path__ + "static/media/arrow-light.e5935565.svg";